import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DepartmentMembersListPage } from '@/pages/department/members/DepartmentMembersListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/department/members/')({
  component: DepartmentMembersListPage,
  validateSearch: dataTableSearchSchema({
    dept: z.string().optional()
  })
});
